import { v3, v2, quat } from "../short3";
import * as Maths3 from "../Maths3";

import { Vector3 } from "three";

const CameraTupleStatics = {
  tp: v3(),
  s: v3(),
};

export class CameraTuple {
  public position: Vector3;
  public target: Vector3;
  public up: Vector3;

  constructor(position?: Vector3 | null, target?: Vector3 | null, up: Vector3 = v3(0, 1, 0)) {
    this.position = position == null ? v3() : position.clone();
    this.target = target == null ? v3() : target.clone();
    this.up = up == null ? v3() : up.clone();
  }

  getSpherical(): Vector3 {
    const tp = CameraTupleStatics.tp;
    const s = CameraTupleStatics.s;
    tp.copy(this.position).sub(this.target);
    Maths3.cartesianToSphericalCoordinates(tp, s);
    return s.clone();
  }

  setSpherical(spherical: Vector3): this {
    const tp = CameraTupleStatics.tp;
    Maths3.sphericalCoordinatesToCartesian(spherical, tp);
    this.position.copy(this.target).add(tp);
    return this;
  }

  setAzimuth(azimuth: number): this {
    const s = this.getSpherical();
    s.z = azimuth;
    this.setSpherical(s);
    return this;
  }

  setPolar(polar: number): this {
    const s = this.getSpherical();
    s.y = polar;
    this.setSpherical(s);
    return this;
  }

  getDirectionToTarget(): Vector3 {
    return v3().copy(this.target).sub(this.position);
  }

  getDirectionToCamera(): Vector3 {
    return v3().copy(this.position).sub(this.target);
  }

  setDistance(distance: number): this {
    const tp = CameraTupleStatics.tp;
    tp.copy(this.position).sub(this.target);
    tp.normalize().multiplyScalar(distance);
    this.position.copy(this.target).add(tp);
    return this;
  }

  distanceToSquared(other: CameraTuple): number {
    return (
      this.position.distanceToSquared(other.position) + this.target.distanceToSquared(other.target)
    );
  }

  clone(): CameraTuple {
    return new CameraTuple(this.position, this.target, this.up);
  }
}
